import React, { Suspense, lazy } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import store from './reducers/store';
import './App.css';
import InitialLoader from './utils/InitialLoader';
import AdminHomeDashboard from './view/antd/AdminHomeDashboard';
import AccountsDrive from './view/drive/AccountsDrive';
import AddAccountDrive from './view/drive/AddAccountDrive';
import UpdateAccountDrive from './view/drive/UpdateAccountDrive';

// Drive
const ProjectsBySubDrive = lazy(() =>
  import('./view/drive/ProjectsBySubDrive')
);
const ProjectVewDrive = lazy(() => import('./view/drive/ProjectVewDrive'));

const UpdateDriveProject = lazy(() =>
  import('./view/drive/UpdateProjectDrive')
);

// Main Dashboard
const DevMainDashboard = lazy(() =>
  import('./view/developer/DevMainDashboard')
);
const DriveMainDashboard = lazy(() =>
  import('./view/developer/DriveMainDashboard')
);

const SuperAdminDashboard = lazy(() =>
  import('./view/superAdmin/SuperAdminDashboard')
);

// Auth
const AdminLoginPage = lazy(() =>
  import('./view/adminDashboard/AdminLoginPage')
);
const DevLoginPage = lazy(() => import('./view/developer/DevLoginPage'));

// Project
const CreateProject = lazy(() => import('./view/developer/CreateProject'));
const UpdateProject = lazy(() =>
  import('./view/projectStepsForm/UpdateProject')
);

// Setting
const ReportSetting = lazy(() => import('./view/settings/ReportSetting'));
const AccountSetting = lazy(() => import('./view/settings/AccountSetting'));
const DatabaseSetting = lazy(() => import('./view/settings/DatabaseSetting'));

// Report
const UpdateReport = lazy(() => import('./view/reportComponents/UpdateReport'));
const AddReport = lazy(() => import('./view/reportComponents/AddReport'));
const AddSubReport = lazy(() => import('./view/reportComponents/AddSubReport'));

// Account
const UpdateAccount = lazy(() =>
  import('./view/accountComponents/UpdateAccount')
);
const AddAccount = lazy(() => import('./view/accountComponents/AddAccount'));

// Database DB Edit
const UpdateDbEdit = lazy(() => import('./view/dbComponents/UpdateDbEdit'));
const AddDbEdit = lazy(() => import('./view/dbComponents/AddDbEdit'));

// GA Report
const GoogleReportGA = lazy(() =>
  import('./view/adminDashboard/GoogleReportGA')
);
const GoogleReportGa3 = lazy(() =>
  import('./view/adminDashboard/GoogleReportGa3')
);

const accSetting = '/accounts/project/:id';
const updateAcc = '/account/edit/:id/:projectId';

function App() {
  return (
    <Provider store={store}>
      <Suspense fallback={<InitialLoader />}>
        <Router>
          <Routes>
            {/* d-rive routes  */}
            <Route
              exact
              path={'/drive/projects'}
              element={<ProjectsBySubDrive />}
            />
            <Route
              exact
              path={'/drive/project'}
              element={<ProjectVewDrive />}
            />
            <Route
              exact
              path="/drive/update/project/:projectId"
              element={<UpdateDriveProject />}
            />
            <Route
              exact
              path="/drive/accounts/project/:id"
              element={<AccountsDrive />}
            />

            <Route
              exact
              path={'/drive/account/edit/:id/:projectId'}
              element={<UpdateAccountDrive />}
            />
            <Route
              exact
              path="/drive/account/add/:id"
              element={<AddAccountDrive />}
            />

            <Route path={'/admin/login'} element={<AdminLoginPage />} />

            <Route
              exact
              path={'/admin/login/:id'}
              element={<AdminLoginPage />}
            />

            <Route
              exact
              path={'/admin/dashboard/:id'}
              element={<AdminHomeDashboard />}
            />

            <Route exact path={'/'} element={<DevLoginPage />} />
            <Route
              exact
              path="/main/dashboard"
              element={<DevMainDashboard />}
            />

            <Route
              exact
              path="/drive/main/dashboard"
              element={<DriveMainDashboard />}
            />
            <Route exact path="/project/create" element={<CreateProject />} />
            <Route exact path="/edit/project/:id" element={<UpdateProject />} />

            <Route exact path={accSetting} element={<AccountSetting />} />
            <Route exact path={updateAcc} element={<UpdateAccount />} />
            <Route exact path="/account/add/:id" element={<AddAccount />} />

            <Route
              exact
              path="/reports/project/:id"
              element={<ReportSetting />}
            />
            <Route exact path="/report/edit/:id" element={<UpdateReport />} />
            <Route
              exact
              path="/report/add/subreport/:id"
              element={<AddSubReport />}
            />

            <Route
              exact
              path="/report/add/single/:id"
              element={<AddReport />}
            />

            <Route
              exact
              path="/databases/project/:id"
              element={<DatabaseSetting />}
            />
            <Route exact path="/database/edit/:id" element={<UpdateDbEdit />} />
            <Route exact path="/database/add/:id" element={<AddDbEdit />} />

            <Route exact path="/google/report" element={<GoogleReportGA />} />
            <Route exact path="/google/ga3" element={<GoogleReportGa3 />} />

            <Route
              exact
              path="/super/all/projects"
              element={<SuperAdminDashboard />}
            />
          </Routes>
        </Router>
      </Suspense>
    </Provider>
  );
}

export default App;
